import { authenticatedFetch } from "@/app/_utils/authenticatedFetch";
import { SupportTicket } from "@/app/@types/support";

export type SupportEmailKind = "new_ticket" | "user_reply";

interface SendSupportEmailArgs {
  kind: SupportEmailKind;
  ticket: SupportTicket;
  replyBody?: string;
  replyFiles?: string[];
  replyAuthorName?: string;
}

// Notifier only. The conversation lives in Firestore; this just tells the
// MountMonitor team something happened. Failures are swallowed so the ticket
// flow never breaks on email.
export const sendSupportEmail = async (
  args: SendSupportEmailArgs
): Promise<boolean> => {
  try {
    const response = await authenticatedFetch("/api/email/support", {
      method: "POST",
      body: JSON.stringify(args),
    });
    return response.ok;
  } catch (error) {
    console.error("Support notifier email failed", error);
    return false;
  }
};

const useSendSupportEmail = () => sendSupportEmail;

export default useSendSupportEmail;
